import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinnedFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.195 6.918s-.372.331-.26.636a4.166 4.166 0 0 1-.753 4.124l-2.57-2.57-.002-.001-.001-.002-.714-.714-.002-.002-.002-.002-2.57-2.57a4.165 4.165 0 0 1 4.124-.752c.258.165.637-.26.637-.26l3.776-3.379 1.715 1.715-3.378 3.777z",
		fill: "#fff"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "m13.907 3.578-2.81-2.81-.004-.004-.67-.671a.317.317 0 0 0-.45.448l.436.436-3.86 3.452a4.8 4.8 0 0 0-4.908 1.156.317.317 0 0 0 0 .448l2.58 2.58-3.814 3.814a.317.317 0 0 0-.08.132L.015 13.59a.317.317 0 0 0 .396.396l1.031-.314a.317.317 0 0 0 .132-.079l3.814-3.814 2.58 2.58a.317.317 0 0 0 .448 0A4.8 4.8 0 0 0 9.571 7.45l3.452-3.86.436.436a.317.317 0 0 0 .448-.448zM.793 13.206l.387-.117L4.938 9.33l-.27-.27L.912 12.82l-.118.386zm8.142-5.652c-.112-.305.26-.636.26-.636l3.378-3.777-1.715-1.715-3.776 3.378s-.379.426-.637.26a4.165 4.165 0 0 0-4.124.754l2.57 2.57.002.001.002.002.714.714.001.002.002.002 2.57 2.57a4.166 4.166 0 0 0 .753-4.125z",
		fill: "#fff"
	})]
});
export default SvgPinnedFilled;
